import React, { useState, useEffect, useCallback } from 'react';

let logoutTimer;

const AuthContext = React.createContext({
    isLoggedIn: false,
    isTenantSelected: false,
    role: "",
    tenants: [],
    selectedPageName: "",
    selectedCountryName: "",
    selectedPartnerName: "",
    selectedUserName:"",
    mustChangePassword: false,
    login: () => { },
    setMustChangePassword: () => { },
    Tenant: () => { },
    removeTenant: () => { },
    setTenants: () => { },
    logout: () => { },
    selectPage: () => { },
    selectCountry: () => { },
    selectPartner: () => { },
    selectUser: () => { },
});

const calculateRemainingTime = (expirationTime) => {
    const currentTime = new Date().getTime();
    const adjExpirationTime = new Date(expirationTime).getTime();

    const remainingDuration = adjExpirationTime - currentTime;

    return remainingDuration;
};

const retrieveStoredTime = () => {
    const storedExpirationDate = localStorage.getItem('expirationTime');

    const remainingTime = calculateRemainingTime(storedExpirationDate);

    if (remainingTime <= 3600) {
        localStorage.removeItem('expirationTime');
        return null;
    }

    return remainingTime;
};

export const AuthContextProvider = (props) => {
    const remainingTime = retrieveStoredTime();
    const TenantStatus = localStorage.getItem('TenantStatus');
    const storedRole = localStorage.getItem('Role');
    const storedTenants = localStorage.getItem('Tenants');
    const selectedPage = localStorage.getItem('SelectedPage');
    const selectedCountry = localStorage.getItem('SelectedCountry');
    const selectedPartner = localStorage.getItem('SelectedPartner');
    const selectedUser = localStorage.getItem('SelectedUser');
    const storedMustChangePassword = localStorage.getItem('MustChangePassword');

    const [isLoggedIn, setIsLoggedIn] = useState(!!remainingTime);
    const [mustChangePassword, setMustChangePassword] = useState(!!storedMustChangePassword);
    const [isTenantSelected, setIsTenantSelected] = useState(!!TenantStatus);
    const [role, setRole] = useState(storedRole != null ? storedRole : "");
    const [tenants, setTenants] = useState(storedTenants != null ? JSON.parse(storedTenants) : []);
    const [selectedPageName, setSelectedPageName] = useState(selectedPage != null ? selectedPage : "");
    const [selectedCountryName, setSelectedCountryName] = useState(selectedCountry != null ? selectedCountry : "");
    const [selectedPartnerName, setSelectedPartnerName] = useState(selectedPartner != null ? selectedPartner : "");
    const [selectedUserName, setSelectedUserName] = useState(selectedUser != null ? selectedUser : "");

    const logoutHandler = useCallback(() => {
        setIsLoggedIn(false);
        setIsTenantSelected(false);
        setRole("");
        setTenants([]);
        setSelectedCountryName("");
        setSelectedPartnerName("");
        setSelectedPageName("");
        setSelectedUserName("");
        setMustChangePassword(false);
        localStorage.removeItem('expirationTime');
        localStorage.removeItem('MustChangePassword');
        localStorage.removeItem('TenantStatus');
        localStorage.removeItem('Role');
        localStorage.removeItem('Tenants');
        localStorage.removeItem('SelectedPage');
        localStorage.removeItem('SelectedCountry');
        localStorage.removeItem('SelectedPartner');
        localStorage.removeItem('SelectedUser');


        if (logoutTimer) {
            clearTimeout(logoutTimer);
        }
    }, []);

    const loginHandler = (Role, Tenants) => {
        setIsLoggedIn(true);
        setRole(Role);
        setTenants(JSON.parse(Tenants));
        const expirationTime = new Date(new Date().getTime() + 1800000);
        localStorage.setItem('expirationTime', expirationTime);
        localStorage.setItem('Role', Role);
        localStorage.setItem('Tenants', Tenants);

        const remainingTime = calculateRemainingTime(expirationTime);

        logoutTimer = setTimeout(logoutHandler, remainingTime);
    };

    const TenantHandler = () => {
        setIsTenantSelected(true);
        localStorage.setItem('TenantStatus', "Selected");
    }

    const RemoveTenantHandler = () => {
        setIsTenantSelected(false);
        localStorage.removeItem('TenantStatus');
        setSelectedCountryName("");
        setSelectedPartnerName("");
        localStorage.removeItem('SelectedCountry');
        localStorage.removeItem('SelectedPartner');
    }

    const setTenantsHandler = (Tenants) => {
        setTenants(JSON.parse(Tenants));
        localStorage.setItem('Tenants', Tenants);
    }
    const selectPageHandler = (PageName) => {
        setSelectedPageName(PageName);
        localStorage.setItem('SelectedPage', PageName);
    }
    const countryHandler = (CountryName) => {
        setSelectedCountryName(CountryName);
        localStorage.setItem('SelectedCountry', CountryName);
    }
    const partnerHandler = (PartnerName) => {
        setSelectedPartnerName(PartnerName);
        localStorage.setItem('SelectedPartner', PartnerName);
    }
    const userHandler = (UserName) => {
        setSelectedUserName(UserName);
        localStorage.setItem('SelectedUser', UserName);
    }
    /**
    * Tracks whether the signed-in user still owes a forced password change.
    * Purely for routing/UX -- the server independently blocks every other action while it is set.
    */
    const mustChangePasswordHandler = (MustChange) => {
        setMustChangePassword(MustChange);
        if (MustChange) {
            localStorage.setItem('MustChangePassword', "true");
        } else {
            localStorage.removeItem('MustChangePassword');
        }
    }
    useEffect(() => {
        if (remainingTime) {
            console.log(remainingTime);
            logoutTimer = setTimeout(logoutHandler, remainingTime);
        }
    }, [remainingTime, logoutHandler]);

    const contextValue = {
        isLoggedIn: isLoggedIn,
        isTenantSelected: isTenantSelected,
        role: role,
        selectedPageName: selectedPageName,
        selectedCountryName: selectedCountryName,
        selectedPartnerName: selectedPartnerName,
        selectedUserName: selectedUserName,
        mustChangePassword: mustChangePassword,
        tenants: tenants,
        login: loginHandler,
        setMustChangePassword: mustChangePasswordHandler,
        Tenant: TenantHandler,
        removeTenant: RemoveTenantHandler,
        setTenants: setTenantsHandler,
        logout: logoutHandler,
        selectPage: selectPageHandler,
        selectCountry: countryHandler,
        selectPartner: partnerHandler,
        selectUser: userHandler,
    };

    return (
        <AuthContext.Provider value={contextValue}>
            {props.children}
        </AuthContext.Provider>
    );
};

export default AuthContext;